import React, { useState, useEffect } from 'react';

import ViewDashboard from './ViewDashboard';
import { connect } from 'react-redux';
import { useApiClient } from '../../clients/apiAuth';

const Dashboard = (props) => {
  const [servicesData, setServicesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const { get } = useApiClient();

  const getServicesReport = async (month, year) => {
    try {
      setIsLoading(true);
      const response = await get(`/rptServicios?MONTH=${month}&YEAR=${year}`);
      console.log('services response: ', response);
      setServicesData(response.data || []);
    } catch (error) {
      console.error('Error fetching services data:', error);
      setServicesData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMonthYearChange = (month, year) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    getServicesReport(month, year);
  };

  // useEffect que solo se ejecuta una vez al montar el componente
  useEffect(() => {
    const loadInitialData = async () => {
      setIsLoading(true);
      try {
        // Cargar datos de servicios
        const initialMonth = new Date().getMonth() + 1;
        const initialYear = new Date().getFullYear();
        const servicesResponse = await get(`/rptServicios?MONTH=${initialMonth}&YEAR=${initialYear}`);
        console.log('services response: ', servicesResponse);
        setServicesData(servicesResponse.data || []);
      } catch (error) {
        console.error('Error fetching initial data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Solo se ejecuta una vez al montar

  return (
    <ViewDashboard
      data={{
        servicesData,
        isLoading,
        selectedMonth,
        selectedYear,
        handleMonthYearChange,
      }}
    />
  );
};

const mapStateToProps = function (state) {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(Dashboard);
